import { useNavigate } from 'react-router';

import { Button } from 'ui';

import { StandaloneTeacherSearchFilters } from './TeacherSearchFilters';
import classes from '../Teacher.module.scss';

export const TeacherSearchErrorWait = () => {
  const navigate = useNavigate();
  return (
    <>
      <main className={classes['teacher-search-error']}>
        <p>
          Подождите несколько минут, пока ваши паспортные данные будут подтверждены.
          Приносим извинения за ожидание.
        </p>
        <div>
          <Button
            onClick={() => navigate('/teacher/search/error-three')}
            variant={'filled'}
            size={'md'}
            shape={'brick'}
            color={'primary'}
          >
            Продолжить
          </Button>
        </div>
      </main>
      <StandaloneTeacherSearchFilters />
    </>
  );
};
